import axios from "axios";
import ele from "element-ui";
import router from "../router/index.js";
import { apiBaseUrl } from "./config.js";

const requests = axios.create({
  baseURL: apiBaseUrl + "/",
  timeout: 6 * 10 * 1000,
});

const LOGIN_URL = "admin-api/auth/app/login";

function normalizeUrl(url) {
  return String(url || "")
    .replace(/^\/+/, "")
    .split("?")[0];
}

function isPlainObject(data) {
  return Object.prototype.toString.call(data) === "[object Object]";
}

/**
 * The REST gateway namespace is form-bound across the existing modules.
 * Keeping this rule at that boundary makes every module behave the same way;
 * content does not need a private URL allow-list.
 */
function isRestApiUrl(url) {
  const normalized = normalizeUrl(url);
  return normalized.startsWith("rest-api/");
}

function toFormParams(data) {
  const params = new URLSearchParams();
  Object.keys(data || {}).forEach((key) => {
    const value = data[key];
    if (value === undefined || value === null) return;
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item === undefined || item === null) return;
        params.append(
          key,
          isPlainObject(item) ? JSON.stringify(item) : String(item),
        );
      });
      return;
    }
    params.append(
      key,
      isPlainObject(value) ? JSON.stringify(value) : String(value),
    );
  });
  return params;
}

function exit() {
  localStorage.removeItem("Authorization");
  localStorage.removeItem("member");
  localStorage.removeItem("admin");
  localStorage.removeItem("isLogin");
  router.push("/");
}

const err = (error) => {
  const status =
    error && error.response
      ? error.response.status
      : error && error.request
      ? error.request.status
      : "";
  const messages = {
    400: "请求错误(400)",
    401: "未授权，请重新登录(401)",
    403: "登录过期，请重新登录",
    404: "请求出错(404)",
    408: "请求超时(408)",
    500: "服务器错误(500)，请稍后重试",
    501: "服务未实现(501)",
    502: "网络错误(502)",
    503: "服务不可用(503)",
    504: "网络超时(504)",
    505: "HTTP版本不受支持(505)",
  };
  if (status) {
    error.message = messages[status] || `连接出错(${status})!`;
    if (status === 401 || status === 403) exit();
  } else if (!error.message) {
    error.message = "连接服务器失败!";
  }
  if (error.message) ele.Message({ message: error.message, type: "error" });
  return Promise.reject(error);
};

requests.interceptors.request.use((config) => {
  const token = localStorage.getItem("Authorization");
  config.headers = config.headers || {};

  if (config.data instanceof FormData) {
    // Let the browser add the multipart boundary.
    delete config.headers["Content-Type"];
    delete config.headers["content-type"];
  } else if (config.data instanceof URLSearchParams) {
    config.headers["Content-Type"] =
      "application/x-www-form-urlencoded;charset=UTF-8";
  } else if (isPlainObject(config.data) && isRestApiUrl(config.url)) {
    config.data = toFormParams(config.data);
    config.headers["Content-Type"] =
      "application/x-www-form-urlencoded;charset=UTF-8";
  } else if (
    config.data !== undefined &&
    config.data !== null &&
    normalizeUrl(config.url) === LOGIN_URL
  ) {
    config.headers["Content-Type"] = "application/json;charset=UTF-8";
  } else if (config.data !== undefined && config.data !== null) {
    config.headers["Content-Type"] = "application/json;charset=UTF-8";
  }

  const url = [
    "rest-api/member/app/student/with-offline-payment",
    "rest-api/member/app/subscriptionPlan/add",
    "rest-api/member/app/subscriptionPlan/delete",
    "rest-api/member/app/subscriptionPlan/edit",
    "rest-api/system/app/chatWelcome/add",
    "rest-api/system/app/chatWelcome/edit",
    "rest-api/member/app/chatWelcome/benefitRecord/edit",
  ];
  if (url.includes(config.url)) {
    config.headers["Content-Type"] = "application/json;charset=UTF-8";
  }

  if (token) {
    config.headers.Authorization = token.startsWith("Bearer ")
      ? token
      : `Bearer ${token}`;
    const clientId = localStorage.getItem("clientId");
    if (clientId) config.headers.clientId = clientId;
  }
  return config;
}, err);

requests.interceptors.response.use((response) => {
  const res = response.data;
  if (!res || res.code === undefined) return res;
  if (res.code === 401) {
    ele.Message({ message: "请先登录", type: "error" });
    router.push("/login");
    return Promise.reject(res);
  }
  if (![0, 200, 203, 206].includes(res.code)) {
    const message = res.msg || res.message;
    if (message) ele.Message({ message, type: "error" });
    return Promise.reject(res);
  }
  return res;
}, err);

export default requests;
